export const transmissionTypes = [
  { value: "A & M", label: "A & M" },
  { value: "Automat", label: "Automat" },
  { value: "Manuell", label: "Manuell" },
  { value: "None", label: "None" },
];